module.exports = __webpack_public_path__ + "img/danamas.c675ef42.png";